<h1 *ngIf="content?.title">{{ content.title }}</h1>
<div *ngIf="content?.description" [internalInnerHtml]="content.description" [userEventSource]="userEventSource"></div>
<air-form #formComponent [controls]="form" (submitted)="submitValues($event)" [disabled]="formDisabled" [userEventSource]="userEventSource">
  <a
    class="button form__button button--full-width button--cta"
    [airButtonLoading]="isSubmitting"
    [ngClass]="{ 'button--disabled': isDisabled }"
    (click)="submit($event)"
  >
    <span>{{ (isDisabled ? "general.label.no_changes" : "general.label.save_changes") | translate }}</span>
  </a>
</air-form>
